import React from 'react';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

// The "mirror" teaser: what follow-on investors run on graduates, and the same tools the cohort
// runs on itself first. The whole page argues this reversal, so the hero states it up front.
const INVESTOR_RUNS = [
    'Corporate & legal diligence, AI-assisted',
    'Financial model stress-test',
    'Technical & code due diligence',
];

const COHORT_RUNS = [
    'Same corporate & legal tools, self-diligenced',
    'Same financial model tools, self-built',
    'Same technical DD tools, self-tested',
];

const AccHeroSection = () => (
    <header className="lp-acc-hero">
        <div className="lp-acc-hero-inner">
            <div>
                <span className="lp-acc-eyebrow" data-lp-reveal>For Accelerators &amp; Venture Studios</span>
                <h1 className="lp-acc-h1" data-lp-reveal data-lp-delay="60">One platform. <em>Every</em> deal, every company, all the way to funding.</h1>
                <p className="lp-acc-lede" data-lp-reveal data-lp-delay="120">Diligentsia is the only platform that runs deal management for your programme and investment-readiness for your cohort — the same platform, the same standard, from application to follow-on close.</p>
                <p className="lp-acc-lede" data-lp-reveal data-lp-delay="160">InvestorMatch with 40+ VCs already on platform</p>
                <div className="lp-acc-ctas" data-lp-reveal data-lp-delay="200">
                    <a className="lp-acc-btn lp-acc-btn--primary" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a call →</a>
                </div>
            </div>

            <div className="lp-acc-mirror" data-lp-reveal data-lp-delay="140">
                <div className="lp-acc-mt-label">What follow-on investors will run on your graduates</div>
                {INVESTOR_RUNS.map(t => (
                    <div className="lp-acc-chip lp-acc-chip--indigo" key={t}><span className="ck">→</span><span>{t}</span></div>
                ))}
                <div className="lp-acc-mirror-line">reversed, before demo day</div>
                <div className="lp-acc-mt-label">What your cohort runs on itself, first</div>
                {COHORT_RUNS.map(t => (
                    <div className="lp-acc-chip lp-acc-chip--coral" key={t}><span className="ck">✓</span><span>{t}</span></div>
                ))}
            </div>
        </div>
    </header>
);

export default AccHeroSection;
